export const topupCategories = [
  {
    id: 'vip',
    label: 'VIP Membership',
    hint: 'Pilih paket VIP 30 hari atau lifetime sesuai kebutuhan karakter.',
    products: [
      {
        id: 'vip_basic_30',
        name: 'Basic Donatur 30 Hari',
        price: 35000,
        description: 'Set VIP Basic Donatur selama 30 hari ke karakter yang dipilih.',
        meta: 'VIP 1 • 30 Hari',
      },
      {
        id: 'vip_advance_30',
        name: 'Advance Donatur 30 Hari',
        price: 65000,
        description: 'Set VIP Advance Donatur selama 30 hari ke karakter yang dipilih.',
        meta: 'VIP 2 • 30 Hari',
      },
      {
        id: 'vip_professional_30',
        name: 'Professional Donatur 30 Hari',
        price: 85000,
        description: 'Set VIP Professional Donatur selama 30 hari ke karakter yang dipilih.',
        meta: 'VIP 3 • 30 Hari',
      },
      {
        id: 'vip_basic_lifetime',
        name: 'Basic Donatur Lifetime',
        price: 145000,
        description: 'Set VIP Basic Donatur permanen ke karakter yang dipilih.',
        meta: 'VIP 1 • Lifetime',
      },
      {
        id: 'vip_advance_lifetime',
        name: 'Advance Donatur Lifetime',
        price: 240000,
        description: 'Set VIP Advance Donatur permanen ke karakter yang dipilih.',
        meta: 'VIP 2 • Lifetime',
      },
      {
        id: 'vip_professional_lifetime',
        name: 'Professional Donatur Lifetime',
        price: 330000,
        description: 'Set VIP Professional Donatur permanen ke karakter yang dipilih.',
        meta: 'VIP 3 • Lifetime',
      },
      {
        id: 'vip_lifetime_donatur',
        name: 'Lifetime Donatur',
        price: 370000,
        description: 'Set VIP Lifetime Donatur permanen ke karakter yang dipilih.',
        meta: 'VIP 4 • Lifetime',
      },
    ],
  },
  {
    id: 'character_level',
    label: 'Level Character',
    hint: 'Bisa beli level satuan Rp10.000 atau pilih paket langsung +3, +5, dan +10 dengan harga lebih hemat.',
    products: [
      {
        id: 'level_unit',
        name: 'Tambah Level Satuan',
        price: 10000,
        description: 'Tambah level sesuai jumlah yang kamu isi. Harga per 1 level adalah Rp10.000.',
        meta: '1 Level = Rp10.000',
        allowQuantity: true,
      },
      {
        id: 'level_plus_3',
        name: 'Tambah Level +3',
        price: 24000,
        description: 'Paket langsung tambah 3 level. Harga paket sudah dipotong Rp2.000 dari harga satuan per level.',
        meta: '+3 Level • Rp8.000/Level',
      },
      {
        id: 'level_plus_5',
        name: 'Tambah Level +5',
        price: 40000,
        description: 'Paket langsung tambah 5 level. Harga paket sudah dipotong Rp2.000 dari harga satuan per level.',
        meta: '+5 Level • Rp8.000/Level',
      },
      {
        id: 'level_plus_10',
        name: 'Tambah Level +10',
        price: 80000,
        description: 'Paket langsung tambah 10 level. Harga paket sudah dipotong Rp2.000 dari harga satuan per level.',
        meta: '+10 Level • Rp8.000/Level',
      },
    ],
  },
  {
    id: 'gold',
    label: 'Topup Gold',
    hint: 'Gold ditambahkan otomatis ke karakter setelah pembayaran berhasil.',
    products: [
      {
        id: 'gold_50',
        name: '250 Gold',
        price: 20000,
        description: 'Menambahkan 50 gold ke karakter yang dipilih.',
        meta: '+250 Gold',
      },
      {
        id: 'gold_100',
        name: '500 Gold',
        price: 40000,
        description: 'Menambahkan 100 gold ke karakter yang dipilih.',
        meta: '+100 Gold',
      },
      {
        id: 'gold_250',
        name: '1000 Gold',
        price: 75000,
        description: 'Menambahkan 250 gold ke karakter yang dipilih.',
        meta: '+250 Gold',
      },
      {
        id: 'gold_500',
        name: '1500 Gold',
        price: 125000,
        description: 'Menambahkan 500 gold ke karakter yang dipilih.',
        meta: '+500 Gold',
      },
    ],
  },
];

export const voucherRules = {};

export function findTopupProduct(categoryId, productId) {
  const category = topupCategories.find((item) => item.id === categoryId) || null;
  const product = category?.products.find((item) => item.id === productId) || null;
  return { category, product };
}

export function formatRupiah(value) {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    maximumFractionDigits: 0,
  }).format(value || 0);
}
